import React, { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { useHandleActionItem } from "../../../hooks/useHandleActionItem.js";
import InputText from "../../../components/forms/InputText.jsx";

const Toast = Swal.mixin({
	toast: true,
	position: "top-end",
	showConfirmButton: false,
	timer: 3000,
	timerProgressBar: true,
	didOpen: (toast) => {
		toast.onmouseenter = Swal.stopTimer;
		toast.onmouseleave = Swal.resumeTimer;
	},
});

function BranchesDetails() {
	const location = useLocation();
	const navigate = useNavigate();
	const locationType = location.state?.type || "";
	const data = useMemo(() => location.state?.data || [], [location.state?.data]);

	const [branch, setBranch] = useState({
		nombre: "",
		direccion: "",
		horarioAtencion: "",
	});
	const { handleDelete, handleSubmit } = useHandleActionItem();

	// Función para convertir datos traducidos a campos originales
	const translateDataToOriginal = (translatedData) => {
		const fieldMapping = {
			"ID Sucursal": "idSucursal",
			"Nombre": "nombre",
			"Dirección": "direccion",
			"Horario Atención": "horarioAtencion"
		};

		const originalData = {};
		for (const [translatedKey, value] of Object.entries(translatedData)) {
			const originalKey = fieldMapping[translatedKey] || translatedKey;
			originalData[originalKey] = value;
		}
		return originalData;
	};

	useEffect(() => {
		if (locationType === "edit" && data) {
			const originalData = translateDataToOriginal(data);
			setBranch(originalData);
		}
	}, [locationType, data]);

	const validateForm = () => {
		if (!branch.nombre || !branch.direccion) {
			Toast.fire({
				icon: "error",
				title: "Nombre y dirección son obligatorios",
				background: "#1e2836",
			});
			return false;
		}
		return true;
	};

	const handleInputChange = (field, value) => {
		setBranch((prev) => ({ ...prev, [field]: value }));
	};

	const handleSubmitForm = async (event) => {
		event.preventDefault();
		if (!validateForm()) return;
		try {
			if (locationType === "add") {
				await handleSubmit("add", "branches", branch);
			} else {
				await handleSubmit("update", "branches", branch);
			}
			navigate("/branches");
		} catch (error) {
			console.log("ERROR", error);
		}
	};

	const handleDeleteForm = async (event) => {
		event.preventDefault();
		await handleDelete({ idSucursal: branch.idSucursal }, "branches", true);
	};

	return (
		<div>
			<form onSubmit={handleSubmitForm}>
				<h1 className="text-center">{locationType === "add" ? "Agregar Sucursal" : "Actualizar Sucursal"}</h1>
				<InputText label="Nombre" value={branch.nombre || ""} setValue={(v) => handleInputChange("nombre", v)} />
				<InputText label="Dirección" value={branch.direccion || ""} setValue={(v) => handleInputChange("direccion", v)} />
				<InputText
					label="Horario de Atención"
					value={branch.horarioAtencion || ""}
					setValue={(v) => handleInputChange("horarioAtencion", v)}
				/>
				<hr />
				<div className="mb-3 d-flex justify-content-around ">
					<button type="submit" className="btn btn-outline-theme btn-lg">
						{locationType === "add" ? "Agregar" : "Actualizar"}
					</button>
					<button onClick={() => navigate("/branches")} className="btn btn-outline-theme btn-lg">
						Atrás
					</button>
					{locationType === "edit" && (
						<button onClick={handleDeleteForm} className="btn btn-outline-danger btn-lg">
							Eliminar
						</button>
					)}
				</div>
			</form>
		</div>
	);
}

export default BranchesDetails;
